import api from '../helpers/axiosHelper';
import { API_ROOT_URL, GLOBAL_RENDERING_INFO } from '../helpers/api';
import { setMyProjectsData } from '../redux/slicers/my-projects/myProjectsSlicer';
import { getLocalStorage } from '../helpers/jsHelper';
import { AUTH_TOKEN } from '../constants/projectConstants';
import axios from 'axios';
import { setRooms } from '../redux/slicers/admin/roomsSlicer';
import { setProps } from '../redux/slicers/admin/propsSlicer';
import { setGlobalRenderingInfo } from '../redux/slicers/globalRenderingInfoSlicer';

export const paginationApi = (query, path, arr) => (dispatch) => {
  const token = getLocalStorage(AUTH_TOKEN);
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  axios
    .get(query, config)
    .then((res) => {
      let new_arr = { ...arr };

      let arr_concat = [...new_arr.results, ...res.data.results.map((a) => a)];
      new_arr['next_link'] = res?.data?.next_link;
      new_arr['results'] = arr_concat;

      switch (path) {
        case 'project':
          dispatch(setMyProjectsData(new_arr));
          break;
        case 'rooms':
          dispatch(setRooms(new_arr));
          break;
        case 'props':
        default:
          dispatch(setProps(new_arr));
          break;
      }
    })
    .catch((err) => console.log(err));
};

export const getGlobalRenderingInfoApi = () => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(GLOBAL_RENDERING_INFO)
    .success((res) => {
      dispatch(setGlobalRenderingInfo(res));
    })
    .error(() => {})
    .send(() => {});
};
